import React from "react";

import { Grid, Typography } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";

import Container from "../../../../components/Container";
import birthPlan02 from "../../../../assets/images/birth-plan-02.png";
import birthPlan03 from "../../../../assets/images/birth-plan-03.png";
import theme from "../../../../constants/theme";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      textAlign: "center",
      padding: theme.spacing(10, 10),
      [theme.breakpoints.only("xs")]: {
        padding: theme.spacing(10, 0),
      },
    },
    heading: {
      paddingBottom: theme.spacing(8),
    },
    subheading: {
      paddingBottom: theme.spacing(3),
      fontSize: 18,
    },
    accent: {
      fontWeight: "bold",
      color: theme.palette.primary.main,
    },
    italic: {
      fontStyle: "italic",
    },
    gridTopMargin: {
      marginTop: theme.spacing(10),
    },
    centerImage: {
      textAlign: "center",
      justifyContent: "center",
    },
  })
);

export default function Introduction() {
  const classes = useStyles();
  return (
    <>
      <Container maxWidth="md" className={classes.root}>
        <Typography variant="h3" className={classes.heading}>
          Zašto ispuniti plan poroda?
        </Typography>
        <Typography className={classes.subheading}>
          Kada dođe vrijeme poroda, morat ćete donositi razne odluke o kojima
          tada nećete imati vremena previše razmišljati. Kreiranjem
          <span className={classes.accent}> osobnog plana poroda</span>{" "}
          unaprijed i na miru odlučujete što želite prije, tijekom i poslije
          poroda, te predajete svoje odluke direktno osoblju rodilišta.
        </Typography>
        <Typography className={classes.italic}>
          * Predlažemo da plan ispunite tek nakon 30. tjedna trudnoće. Nemojte
          ga zaboraviti nositi na bolničke preglede te na sam porod.
        </Typography>
      </Container>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item md={6} xs={12} className={classes.centerImage}>
            <img
              src={birthPlan02}
              alt="plan poroda"
              style={{ width: "15rem" }}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography variant="h3" className={classes.heading}>
              Vaš<span className={classes.accent}> porod</span>, vaše želje
            </Typography>
            <Typography className={classes.subheading}>
              Doktori, primalje, pratnja... svi su ovdje da pomognu{" "}
              <span className={classes.accent}>vama</span>.
            </Typography>
            <Typography className={classes.subheading}>
              No, koliko god svi bili spremni pomoći, samo vi znate što vam je
              stvarno potrebno. Ispunjavanje plana poroda vam omogućava da jasno
              izrazite ono što želite.
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          className={classes.gridTopMargin}
          alignItems="center"
        >
          <Grid item md={6} xs={12}>
            <Typography variant="h3" className={classes.heading}>
              Jesu li moji podaci
              <span className={classes.accent}> sigurni?</span>
            </Typography>
            <Typography variant="body1" className={classes.subheading}>
              Naravno! Svjesni smo da se radi o unosu osjetljivih podataka, tako
              da naša stranica
              <span className={classes.accent}> ne sprema</span> nikakve podatke
              koje unosite!
            </Typography>
            <Typography className={classes.subheading}>
              Podaci vašeg plana poroda su spremljeni isključivo na vaš uređaj
              (tako da je bitno skinuti PDF prije gašenja stranice :) )
            </Typography>
            <Typography className={classes.italic}>
              * Ako primijetite da su kod ponovnog otvaranja stranice vaši
              podaci ostali zapamćeni, ne brinite! Radi se o privremenoj pohrani
              vašeg internet preglednika koji, ovisno o postavkama, privremeno
              sprema slične podatke sa svih stranica.
            </Typography>
          </Grid>
          <Grid item md={6} xs={12} className={classes.centerImage}>
            <img
              src={birthPlan03}
              alt="plan poroda"
              style={{ width: "15rem" }}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
